import { EpicEvent_RequestToCloseApp, } from './consts.js';
export const Epic_ErrorCode = {
    0: 'The order key specified by the web app could not be mapped',
    1: 'The order could not be replaced. This means that in the replace workflow, a new order could not be placed (though the triggering order might have been removed).',
    2: 'The order could not be removed.',
    3: 'Defaults were invalid.',
    4: 'The order could not be placed.',
    5: 'Action in progress. This means that two messages were posted back-to-back without waiting for a response from the first.',
    7: 'An action was posted which requires a token, but no token was provided.',
    8: 'An action was not allowed in a workflow, such as removing a trigger order when no trigger order is present.',
    9: 'An action was attempted which does not exist.',
    10: 'A flowsheet row was invalid.',
    11: 'An NDC ID was not mapped to an order.',
    12: 'An action to place an order is configured with the wrong arguments.',
    13: 'An action to place an order by NDC ID is configured with the wrong arguments.',
    14: 'An AnnotateOrders action attempted to file invalid values for indications of use, order-specific questions, or decision support score/session ID.',
    15: 'An action is not allowed during closing.',
    16: 'An invalid SubscriptionRequest was sent.',
    18: 'A browser launch was attempted for a URL that is not allowlisted.',
    19: 'The SmartSet could not bne added because the key was not mapped to the ID does not exist.',
    20: 'Invalid arguments specified fot the PostProtocol action.',
    21: 'A SmartSet was attempted to be added using ProtocolID but the web integration record does not allow this.',
    22: 'A SmartSet could not be placed.',
    23: 'Conflicting SmartSets were attempted to be placed together. For example, a user tried to place a Pathway with a SmartSet.',
    24: 'The diagnosis could not be added.',
    25: 'Invalid BehaviorAfterApply argument in the message.',
    26: 'The BehaviorAfterApply argument is prohibited in the current workflow.',
    27: 'No actions to apply because the actions queue is empty.',
    28: 'The lock on the patient diagnosis list could not be obtained.',
    29: 'An unknown error occurred in the diagnosis framework.',
    30: 'An unknown error occurred trying to revise a third-party diagnosis into a diagnosis that can be added to the patient diagnosis list.'
};
//# sourceMappingURL=types.js.map